// Import Libs and Handlers
import React from 'react';
import Renderer from '@tencent/gems-renderer-react';
import { withJimuComponentAdaptor } from '@tencent/gems-component-adaptor/esm/jimu';
import { injectStyle } from '../handlers/shared/injectStyle';
import { selectVersion } from '../handlers/shared/selectVersion';

// Import Components
import Image from '../libraries/base/components/Image';
import FormContainer from '../libraries/fudao/components/FormContainer';
import FormCheckSelect from '../libraries/fudao/components/FormCheckSelect';
import FormVerifyCode from '../libraries/fudao/components/FormVerifyCode';
import BottomBar from '../libraries/fudao/components/BottomBar'

// Import Plugins
import GDTExposeReport from '../libraries/fudao/plugins/GDTExposeReport';
import Share from '../libraries/base/plugins/Share'

// Import Actions
import ScrollToComponent from '../libraries/base/actions/ScrollToComponent'

let ReactDOMServer;
if(process.env.SSR) {
  // TODO: Remove
  require('@babel/polyfill/noConflict');
  ReactDOMServer = require('react-dom/server');
}

// Global Style
injectStyle(`body {
	border: 1px none #161616 !important;
background-color: #ffffff !important;
background-repeat: undefined !important;
background-size: undefined !important;
background-position: undefined !important;
}`, '__impage_injected-global-styles');

// Auto Inject Style
injectStyle(``, '__impage_injected-component-styles');

// Global Data
const meta = {
    "title": "腾讯企鹅辅导",
    "desc": "原价399元精品课，现0元免费领取",
    "start": new Date('Sat Jul 31 2021 17:09:43 GMT+0800 (China Standard Time)'),
    "end": new Date('Sat Jul 31 2021 17:09:43 GMT+0800 (China Standard Time)'),
    "actId": 3147,
    "actKey": "congzhu8_8_",
    "containerType": "web",
    "isTemplate": false,
    "isEditor": false,
    "isTestEnv": false
};

const _global = {
    "jumpUrl": "",
    "reportPageName": ""
};

// Inject JIMU_Vars
if (typeof window !== 'undefined') {
  if(!window['JIMU_VARS']){
    Object.defineProperty(window, 'JIMU_VARS', {
      value: {
    "key": "congzhu8_8_",
    "actStartTime": "2021-07-31T09:09:43.000Z",
    "actEndTime": "2021-07-31T09:09:43.000Z",
    "isJimu": false,
    "jumpUrl": "",
    "reportPageName": ""
},
      writable: false,
      configurable: false,
    });
  }

  // Inject Global
  if(!window['VISION']){
    Object.defineProperty(window, 'VISION', {
      value: { meta, global: _global },
      writable: false,
      configurable: false,
    });
  }
}

// Actions
const actions = {
    "7": {
        "action": ScrollToComponent,
        "id": 7,
        "projId": 1,
        "projKey": "base",
        "name": "ScrollToComponent",
        "info": {
            "name": "滚动到该组件",
            "author": "elliothu"
        }
    }
};

// Components
const components = {
    "5": {
        "component": Image,
        "id": 5,
        "projId": 1,
        "projKey": "base",
        "name": "Image",
        "info": {
            "name": "图片",
            "desc": "图片组件",
            "author": "elliothu"
        },
        "__implementHotArea": true
    },
    "15": {
        "component": FormContainer,
        "id": 15,
        "projId": 2,
        "projKey": "fudao",
        "name": "FormContainer",
        "info": {
            "name": "辅导表单容器",
            "desc": "用于留资等需求",
            "author": "elliothu"
        }
    },
    "19": {
        "component": FormCheckSelect,
        "id": 19,
        "projId": 2,
        "projKey": "fudao",
        "name": "FormCheckSelect",
        "info": {
            "name": "选项组",
            "desc": "选项按钮组，支持单选或多选",
            "author": "elliothu"
        }
    },
    "22": {
        "component": FormVerifyCode,
        "id": 22,
        "projId": 2,
        "projKey": "fudao",
        "name": "FormVerifyCode",
        "info": {
            "name": "手机号+验证码",
            "desc": "用于验证手机号",
            "author": "elliothu"
        }
    },
    "34": {
        "component": BottomBar,
        "id": 34,
        "projId": 2,
        "projKey": "fudao",
        "name": "BottomBar",
        "info": {
            "name": "底部 Bar",
            "desc": "辅导底部固定 Bar",
            "author": "elliothu"
        }
    }
};

// Plugin
const plugins = {
    "2": {
        "plugin": GDTExposeReport,
        "id": 2,
        "name": "GDTExposeReport",
        "info": {
            "name": "广点通曝光上报",
            "desc": "进入页面时上报广点通页面曝光行为",
            "author": "elliothu"
        }
    },
    "5": {
        "plugin": Share,
        "id": 5,
        "name": "Share",
        "info": {
            "name": "分享配置",
            "desc": "配置分享内容，监听分享事件，支持微信 & 手Q",
            "author": "elliothu"
        }
    }
};

// SchemaMap
const schemaMap = {
    "9a5f4af3": {
        "components": [
            {
                "id": 5,
                "key": 0,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1596006354761.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            },
            {
                "id": 15,
                "key": 1,
                "data": {
                    "buttonText": "立即申请0元课程",
                    "successButtonText": "已预约",
                    "successTitle": "成功",
                    "successText": "预约成功",
                    "messageType": "toast",
                    "forbidResubmit": true
                },
                "style": {
                    "buttonTextColor": "#fff",
                    "buttonBackgroundColor": "#ff9f00"
                },
                "commonStyle": {
                    "margin": "0px auto 0px auto",
                    "padding": "16px 12px 16px 12px",
                    "border": "1px none #161616",
                    "backgroundColor": "#fff"
                },
                "wrapperStyle": {},
                "actions": [],
                "children": [
                    {
                        "id": 19,
                        "key": 4,
                        "data": {
                            "label": "年级",
                            "options": [
                                "一年级",
                                "二年级",
                                "三年级",
                                "四年级",
                                "五年级",
                                "六年级",
                                "初一",
                                "初二",
                                "初三",
                                "高一",
                                "高二",
                                "高三"
                            ],
                            "multi": false
                        },
                        "style": {},
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    },
                    {
                        "id": 22,
                        "key": 5,
                        "data": {
                            "timeout": 60,
                            "failWording": "验证码发送失败",
                            "successWording": "验证码发送成功",
                            "disableVoiceVerify": true
                        },
                        "style": {},
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    }
                ]
            },
            {
                "id": 5,
                "key": 20,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1603352705655.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            },
            {
                "id": 5,
                "key": 53,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1594973727993.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            },
            {
                "id": 5,
                "key": 36,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1594973750932.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            },
            {
                "id": 5,
                "key": 12,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1594980357321.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            },
            {
                "id": 5,
                "key": 51,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1603352865705.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            },
            {
                "id": 34,
                "key": 44,
                "data": {
                    "buttonText": "0元领取",
                    "titleText": "价值￥399的课程",
                    "subTitleText": "立即免费预约"
                },
                "style": {
                    "titleColor": "#343a48",
                    "subTitleColor": "#bbbbbb",
                    "buttonTextColor": "#fff",
                    "buttonColor": "#cb2208",
                    "bgColor": "#fff"
                },
                "commonStyle": {},
                "wrapperStyle": {},
                "actions": [
                    {
                        "id": 9007199254740991,
                        "key": 48,
                        "data": {
                            "actionName": "__impage__component-event-show"
                        },
                        "trigger": "__impage_action_trigger_leave_view",
                        "target": 44
                    },
                    {
                        "id": 7,
                        "key": 49,
                        "data": {
                            "smooth": true
                        },
                        "trigger": "clickButton",
                        "target": 1
                    }
                ],
                "position": {
                    "position": "fixed",
                    "bottom": 0,
                    "left": 0
                }
            },
            {
                "id": 5,
                "key": 52,
                "data": {
                    "src": "//cdn.vision.qq.com/prod/imgs/static/static_1596006506104.jpg",
                    "hotAreas": []
                },
                "style": {},
                "commonStyle": {
                    "maxWidth": "100%",
                    "margin": "0px auto 0px auto",
                    "border": "1px none #161616"
                },
                "wrapperStyle": {
                    "backgroundColor": "transparent",
                    "backgroundRepeat": "repeat-y",
                    "backgroundSize": "auto",
                    "backgroundPosition": "center top"
                },
                "actions": [],
                "__implementHotArea": true,
                "fixedWrapperStyle": {}
            }
        ],
        "plugins": [
            {
                "id": 2,
                "key": 25,
                "data": {}
            },
            {
                "id": 5,
                "key": 26,
                "data": {
                    "wording": "分享完成"
                }
            }
        ],
        "version": {
            "versionId": "9a5f4af3",
            "versionName": "default"
        }
    }
};

export default function App({ version }) {
  const schema = selectVersion(schemaMap, version);
  return (
    <Renderer
      schema={schema}
      materials={{ components, plugins, actions }}
      autoParseStyle={false}
      global={_global}
      meta={meta}
      withComponentAdaptor={withJimuComponentAdaptor}
    />
  );
}

export function renderToString() {
  return ReactDOMServer.renderToString(<App />);
}
